import { useContext } from 'react';
import { AdminContext } from '../context/AdminContext';
import AppIcons from '../icons';
import ToolbarIcons from '../icons/toolbar';
import React from 'react';

const fa = {
  splash: 'لحظات خوبی را تجربه کنید',
  chatDemo: {
    you: 'شما',
    yourText: 'خبر میدم بهت',
    contact: 'مخاطب',
    contactText:
      'لورم ایپسوم یا طرح‌نما  به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این متن به عنوان عنصر',
  },
  reload: 'بارگذاری مجدد برنامه',
  offlineText: 'اتصال به اینترنت را بررسی کنید',
  onlineStatus: 'وضعیت آنلاین',
  onlineStatusOn: 'وضعیت آنلاین بودن شما روشن است .',
  onlineStatusOff: 'وضعیت آنلاین بودن شما خاموش است .',
  darkMode: 'حالت تاریک',
  darkModeOn: 'حالت تاریک فعال است .',
  darkModeOff: 'حالت تاریک غیر فعال است .',
  folderPart: {
    menu: [
      { id: 0, name: 'پیام‌ها', fileType: 'message' },
      { id: 1, name: 'تصاویر', fileType: 'image' },
      { id: 2, name: 'ویدیو‌ها', fileType: 'video' },
      { id: 3, name: 'موسیقی', fileType: 'music' },
      { id: 4, name: 'فایل‌ها', fileType: 'pdf,doc' },
      { id: 5, name: 'سایر', fileType: 'zip,rar' },
    ],
  },
  settingModal: {
    menu: [
      {
        id: 1,
        name: 'تغییر تم',
        icon: (
          <ToolbarIcons.themeIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 2,
        name: 'زبان‌',
        icon: (
          <ToolbarIcons.LanguageIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 3,
        name: 'پس‌زمینه',
        icon: (
          <ToolbarIcons.backgroundIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 4,
        name: 'فایل',
        icon: (
          <ToolbarIcons.FileIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 5,
        name: 'ویرایش پروفایل',
        icon: (
          <ToolbarIcons.EditProfileIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 8,
        name: 'تغییر رمزعبور',
        icon: (
          <ToolbarIcons.changePasswordIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'18px'}
            height={'18px'}
          />
        ),
      },
      {
        id: 6,
        name: 'خروج',
        icon: (
          <ToolbarIcons.ExitIcon
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 7,
        name: 'حذف حساب کاربری',
        icon: (
          <ToolbarIcons.DeleteAccount
            // fill={'#999'}
            fill={`#000`}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      // { id: 4, name: 'فایل‌ها' },
    ],
  },
  deleteAccount: {
    title: '',
    description: 'آیا مطمئن هستید می‌خواهید حساب کاربری خود را حذف کنید؟',
    confirmText: 'بله',
    rejectText: 'خیر',
  },
  deleteFav: {
    title: '',
    description: 'آیا مطمئن هستید می‌خواهید پیام را حذف کنید؟',
    confirmText: 'بله',
    rejectText: 'خیر',
  },
  // noContent: 'به منظور ارسال پیام، کاربر مورد نظر خود را انتخاب کنید.',
  noContent: 'پیام رسان اُچت در خدمت شما',
  startConversation: 'ارسال پیام: ',
  startConversationTo: 'ارسال پیام به ',
  conversation: 'گفتگو',
  themeText: 'تنظیمات',
  languages: 'زبان‌ها',
  search: 'جستجو',
  errorRequired: 'این فیلد ضروری است.',
  themeArray: [
    {
      color: 'white',
      text: 'صورتی',
    },
    // { color: 'black', text: 'مشکی' },
    { color: 'green', text: 'سبز' },
    { color: 'blue', text: 'آبی' },
  ],
  time: {
    some: 'چند',
    seconds: ' ثانیه پیش',
    minutes: ' دقیقه پیش',
    hours: ' ساعت پیش',
    days: ' روز پیش',
    weeks: ' هفته پیش',
    years: ' سال پیش',
  },
  name: 'اُچت',
  signupText: 'ثبت‌نام',
  description:
    'ویژگی‌های منحصر به فرد ما، ما را از دیگران متمایز می‌کند. چت کنید، ارتباط برقرار کنید و گفتگوهایی را ایجاد کنید که به یاد ماندنی باشند.',
  appTitle: 'اُچت',
  login: {
    description: ' برای ورود به اُچت اطلاعات کاربری خود را وارد نمایید.',
    toSignup: {
      description: ' حساب کاربری ندارید؟',
      button: 'ثبت‌نام کنید',
    },
    title: 'ورود',
    text: 'برای استفاده از پیام رسان لطفا وارد حساب کاربریه خود شوید .',
    formButton: 'ورود',
    mobile: 'موبایل',
    mobileError: 'تلفن همراه نادرست است',
    mobilePlaceHolder: 'مثال: ۹xxxxxxxx ',
    password: 'گذرواژه',
    passwordError: 'رمز عبور نادرست است',
    forgetButton: 'کلمه عبور خود را فراموش کردم؟',
    createAccount: {
      description:
        'برای استفاده از امکانات اُچت مانند آپلود ویدیو، گذاشتن نظر و غیره، در اُچت ثبت‌نام کنید',
      title: 'ورود به اُچت',
      button: 'ایجاد حساب کاربری',
    },
  },
  replyToUser: 'پاسخ به',
  replyToMessage: 'پاسخ به این پیام',
  toolbar: {
    exit: 'خروج',
    fileIcon: 'فایل',
    chatIcon: 'چت',
    theme: {
      title: 'تغییر تم',
    },
    language: {
      title: ' زبان',
    },
  },
  userDashboard: [
    {
      id: 1,
      name: 'آپلود',
    },
    {
      id: 2,
      name: 'ویدیو‌ها',
    },
  ],
  chatPage: {
    you: 'شما',
    navTitle: ' کاربران فعال',
    footer: {
      InputPlaceHolder: 'متن پیام',
      notConnectText: 'برای ارسال نظر خود وارد حساب کاربری شوید.',
      sendButton: 'ارسال',
      uploadButton: 'آپلود',
    },
  },
  chatFooter: {
    invalidType: 'فایل نامعتبر است.',
    unBlock: 'حذف بلاک',
  },
  userMessage: {
    delete: 'از گروه حذف شد.',
    left: 'از گروه خارج شد.',
    add: 'به گروه اضافه شد.',
  },
  groupMember: {
    owner: 'سازنده گروه',
  },
  groupMemberMore: [
    {
      id: 1,
      chosen: 'ارتقا به ادمین',
      icon: <AppIcons.AdminIcon fill={'#000'} />,
      notChosen: 'حذف دسترسی ادمین',
    },
    {
      id: 2,
      chosen: 'حذف',
      icon: <AppIcons.deleteIcon fill={'#000'} />,
      notChosen: 'حذف',
    },
  ],
  chatBar: {
    userMore: [
      {
        id: 1,
        chosen: 'پین کردن',
        icon: <AppIcons.pinIconSetting fill={'#000'} className={`moreBox`} />,
        notChosen: 'حذف پین',
      },
      {
        id: 2,
        chosen: 'حذف',
        icon: <AppIcons.deleteIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'حذف',
      },
      {
        id: 8,
        chosen: 'با صدا',
        icon: (
          <AppIcons.muteIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'بی صدا ',
        notchosenIcon: (
          <AppIcons.unMuteIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
      },
      {
        id: 3,
        chosen: 'مسدود کردن',
        icon: <AppIcons.BlockIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'حذف بلاک',
      },
      {
        id: 4,
        chosen: 'ویرایش',
        icon: (
          <AppIcons.EditIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'ویرایش',
      },
      {
        id: 5,
        chosen: 'خروج از گروه',
        icon: (
          <ToolbarIcons.ExitIcon
            width={'16px'}
            height={'16px'}
            fill={'#000'}
            className={`moreBox`}
          />
        ),
        notChosen: 'خروج از گروه',
      },
      {
        id: 6,
        chosen: 'اعضای گروه',
        icon: <AppIcons.GroupIcon fill={'#000'} className={`moreBox`} />,
        notChosen: ' اعضای گروه',
      },
      {
        id: 7,
        chosen: 'پاک کردن تاریخچه',
        icon: <AppIcons.ClearHistoryIcon fill={'#000'} className={`moreBox`} />,
        notChosen: 'پاک کردن تاریخچه',
      },
      // { id: 3, text: 'اشتراک‌ گداری', icon: <AppIcons.DownloadIcon /> },
    ],
  },
  setting: {
    more: [
      {
        id: 1,
        chosen: 'فایل',
        icon: (
          <ToolbarIcons.FileIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 5,
        chosen: 'ویرایش پروفایل',
        icon: (
          <ToolbarIcons.EditProfileIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 3,
        chosen: 'تنظیمات',
        icon: (
          <ToolbarIcons.SettingsIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
      {
        id: 4,
        chosen: 'ایجاد گروه',
        icon: (
          <AppIcons.GroupIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
          />
        ),
      },
      {
        id: 2,
        chosen: 'خروج',
        icon: (
          <ToolbarIcons.ExitIcon
            fill={'#999'}
            className={`flex flex-col justify-center items-center `}
            width={'20px'}
            height={'20px'}
          />
        ),
      },
    ],
  },
  footerMoreBox: [
    { id: 1, name: 'اشتراک گذاری کاربر', icon: <AppIcons.userShareIcon /> },
  ],
  personalInfoModal: {
    title: 'نام',
    username: 'نام کاربری',
    groupname: 'نام گروه',
    description: 'توضیحات',
    users: 'کاربران',
    submit: 'ثبت',
    edit: 'ویرایش',
    delete: 'حذف',
    placeholder: 'اینجا بنویسید ...',
    introTitleAdd: 'اضافه کردن افراد به گروه',
    introTextAdd: 'افراد را به گروه اضافه کنید و با آن ها در ارتباط باشید .',
    introTitleEdit: 'ویرایش کردن گروه',
    introTextEdit: 'اسم , عکس , افراد گروه و یادسترسی ها را ویرایش کنید .',
  },
  group: {
    createGroup: 'ایجاد گروه',
    editGroup: 'ویرایش گروه',
  },
  noInfoFound: 'اطلاعاتی یافت نشد !',
  shareUserHeader: 'اشتراک گذاری کاربر',
  forwardHeader: 'ارسال به',
  newMessage: 'پیام جدید',
  newFile: 'فایل جدید',
  countryCode: {
    error: 'کشور موردنظر پشتیبانی نمی‌شود.',
    code: 'پیش شماره',
    placeholder: '۹۸',
  },
  signup: {
    mobile: {
      title: 'مرحله 1 / 2: ورود شماره همراه',
      description: ' شماره تلفن همراه خود را برای ثبت‌نام وارد نمایید.',
      button: 'ادامه',
      input: {
        placeholder: 'مثال: ۹xxxxxxxx  ',
        title: 'تلفن همراه ',
        error: 'تلفن همراه نادرست است',
      },
    },
    code: {
      title: 'مرحله 2 / 2: ورود کد تایید',
      description: 'کد ارسالی به تلفن همراه خود را وارد کنید.',
      button: 'ادامه',
      input: {
        placeholder: 'مثال: ۹xxxxxxxx  ',
        title: 'کد ارسالی',
        error: 'کد دریافتی را به صورت عدد چهار رقمی وارد کنید.',
      },
      resend: ' ارسال مجدد کد',
    },
    success: {
      title: 'تبریک می‌گوییم.',
      description: 'ثبت‌نام شما کامل شد. خوش آمدید. ',
      button: 'ورود  ',
    },
  },
  forgetPassword: {
    mobile: {
      title: ' مرحله 1 / 2: ورود شماره همراه',
      description:
        'برای تغییر رمز عبور خود   شماره تلفن همراه خود را وارد نمایید.',
      button: 'ادامه',
      input: {
        placeholder: 'مثال: ۹xxxxxxxx  ',
        title: 'تلفن همراه ',
        error: 'تلفن همراه نادرست است',
      },
    },
    code: {
      title: ' مرحله 2 / 2: ورود کد ارسالی',
      description: 'کد ارسالی به تلفن همراه خود را وارد نمایید.',
      button: 'ثبت',
      input: {
        placeholder: 'مثال: ۹xxxxxxxx  ',
        title: 'کد ارسالی',
        error: 'کد دریافتی را به صورت عدد چهار رقمی وارد کنید.',
      },
    },
    success: {
      title: 'تغییر رمز با موفقیت انجام شد.',
      description: 'رمز جدید به شماره همراه شما ارسال گردید.',
      button: 'ورود  ',
    },
  },
  changePassword: {
    prePass: {
      title: 'رمزعبور قبلی ',
      error: 'رمزعبور قبلی وارد کنید.',
    },
    newPass: {
      title: 'رمزعبور جدید ',
      error: 'رمزعبور جدید وارد کنید.',
    },
    reNewPass: {
      title: 'تکرار رمزعبور جدید ',
      error: 'رمزعبور جدید را مجدد وارد کنید.',
    },
    notMatch: 'رمزی که برای بار دوم وارد کردید، مطابقت ندارد.',
    submit: 'ثبت',
  },
  haveAccount: {
    title: ' حساب کاربری دارید؟',
    button: ' وارد شوید',
  },
  forwarded: 'هدایت شده',
  uploadVideo: {
    noFileUploaded: 'هیچ فایلی آپلود نشده است.',
    isUploading: 'درحال بارگذاری...',
    videoIsReady: ' ویدیوی شما آماده انتشار است',
    from: 'از',
    megaByte: 'مگابایت',
    proccessing: 'ویدیو در حال آماده‌سازی است',
    chooseCover: ' انتخاب تصویر کاور',
    chooseCoverError: 'عکس کاور را انتخاب کنید',
    uploadImage: ' بارگذاری تصویر',
    uploadedImage: ' تصویر بارگذاری شده',
    empty: 'خالی',
    submit: 'انتشار',
    creating: 'در حال ایجاد',
    videoForm: {
      titleInput: ' عنوان ویدیو (اجباری)',
      titleError: 'این فیلد اجباری است',
      titlePlaceholder: 'عنوان ویدیو را وارد کنید',
      contentInput: 'توضیحات  (اجباری) ',
      contentError: 'توضیحات  مربوط به ویدیو را وارد کنید',
      contentPlaceholder: 'توضیحات مربوط به ویدیو را وارد کنید',
      tagTitle: ' افزودن برچسب ',
      tagError: 'این فیلد اجباری است',
      tagPlaceholder: ' افزودن برچسب ',
      tag: 'برچسب',
      addTag: 'افزودن',
    },
  },
};
export default fa;
